import AnimationOpen from '@/components/MobileSales/Contents/AnimationOpen';
import SvgImage from '@/components/Module/SvgImage';
import useAi from '@/components/Record/hooks/useAi';
import { useFindPassport } from '@/hooks/apiHooks';
import { MyInfoState } from '@/recoil/atom';
import { StyledSVGButton } from '@/styles/GlobalStyles';
import { RecordFilter, RecordMode } from '@/types/api';
import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useAtomValue } from 'jotai';
import OfflineIcon from '@/public/icons/record/offline.svg';
import OnlineIcon from '@/public/icons/record/online.svg';
import XIcon from '@/public/icons/record/x.svg';
import { useTranslation } from 'react-i18next';
import useLayoutSize from '@/hooks/useLayoutSize';
import { useNetworkState } from 'react-use';

const SubHeader = () => {
  const { t } = useTranslation();
  const { isOwner } = useAi();
  const { passportId } = useAtomValue(MyInfoState);
  const { data } = useFindPassport(passportId);
  const { setValue, watch } = useFormContext<RecordFilter>();

  const { online: isOnline } = useNetworkState();

  const [open, setOpen] = useState(false);
  const { isMobile } = useLayoutSize();

  const [nowIsOnline, setNowIsOnline] = useState(false);
  const [currentIsOnline, setCurrentIsOnline] = useState<boolean | undefined>(
    true,
  );

  const handleRecordMode = () => {
    setValue('mode', RecordMode.Meeting);
    data &&
      setValue('internal', [
        {
          passportId: data.passportId,
          name: data.detail.name,
          departmentName: data.detail.departmentName,
          positionName: data.detail.positionName,
          divisionName: data.detail.divisionName,
          profileImageUrl: data.detail.profileImageUrl,
        },
      ]);
    setOpen(false);
  };

  const handleNoteMode = () => {
    setValue('mode', RecordMode.Note);
    setOpen(false);
  };

  useEffect(() => {
    if (watch('mode') === RecordMode.NEW && isOwner) {
      setOpen(true);
    }
  }, [watch('mode'), isOwner]);

  useEffect(() => {
    if (isOnline) {
      !currentIsOnline && setNowIsOnline(true);
    } else {
      setNowIsOnline(false);
    }
    setCurrentIsOnline(isOnline);
  }, [isOnline]);

  return (
    <>
      {nowIsOnline && (
        <AnimationOpen>
          <StyledContainer
            style={{
              background:
                'linear-gradient(0deg, rgba(67, 177, 111, 0.08) 0%, rgba(67, 177, 111, 0.08) 100%), var(--dk-bg, #FFF)',
              color: '#43B16F',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
              }}
            >
              <OnlineIcon style={{ color: '#43B16F' }} />
              네트워크 연결이 복구되어 작성 중인 내용이 저장되었습니다.
            </div>

            <StyledSVGButton onClick={() => setNowIsOnline(false)}>
              <XIcon width={11} height={11} stroke={'#43B16F'} />
            </StyledSVGButton>
          </StyledContainer>
        </AnimationOpen>
      )}
      {!isOnline && (
        <AnimationOpen>
          <StyledContainer
            style={{
              background:
                'linear-gradient(0deg, rgba(245, 80, 96, 0.08) 0%, rgba(245, 80, 96, 0.08) 100%), var(--dk-bg, #FFF)',
              color: 'var(--dk-danger, #F55060)',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: isMobile ? 'flex-start' : 'center',
                justifyContent: 'center',
                gap: '8px',
              }}
            >
              <div
                style={{
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <OfflineIcon
                  style={{
                    color: 'red',
                  }}
                />
              </div>
              네트워크 연결이 끊겼습니다. 복구될 때까지 작성 중인 내용은
              브라우저에 임시 저장됩니다.
            </div>
          </StyledContainer>
        </AnimationOpen>
      )}
      {open ? (
        <AnimationOpen>
          <StyledContainer>
            <div style={{ display: 'flex', gap: '8px' }}>
              <div>{t('회의록을 작성중이신가요?')}</div>
              <button
                style={{ padding: 0, color: 'var(--dk-accent, #06C)' }}
                onClick={handleRecordMode}
              >
                {t('회의록 템플릿 불러오기')}
              </button>
            </div>
            <StyledSVGButton onClick={handleNoteMode}>
              <SvgImage name={'x'} />
            </StyledSVGButton>
          </StyledContainer>
        </AnimationOpen>
      ) : null}
    </>
  );
};
export default SubHeader;

const StyledContainer = styled.div`
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  align-items: center;
  background-color: var(--dk-bg-subtle, #f9fafb);
  justify-content: space-between;
`;
